module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8b29b690f3376eeef1980f90e0ebe006.png";